import React from "react";
import {
    StyleSheet,
    Text,
    View,
    ImageBackground,
    ScrollView,
    TouchableOpacity,
    TextInput,
    Image,
    // ToastAndroid
} from 'react-native';

import {RFValue} from "react-native-responsive-fontsize";


import { useNavigation , useFocusEffect} from '@react-navigation/native';

import { LinearGradient } from 'expo-linear-gradient';
import { FontAwesome } from '@expo/vector-icons';

import { MaterialCommunityIcons } from '@expo/vector-icons';

import { FontAwesome5 } from '@expo/vector-icons';
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";


import { AntDesign } from '@expo/vector-icons';
import { Entypo } from '@expo/vector-icons';

import Config from "../../components/Config";


// import Toast from 'react-native-tiny-toast';
import ToastNotification from 'react-native-toast-notification'
const Profile = ({navigation})=>{




    let [toast,setToast] = React.useState(false);
    let [datas,setdatas] = React.useState({
        reward : '0' ,
        teamReward : '0' ,
        walletAmount : '0',
        full_name : 'Loading ... ',
        avatar :'https://metamax.network/public/no-avatar.jpeg',
        myPack : [],
    });
    let interval = false;


    let [timers,setTimers] = React.useState(false);

    let [pack,setpack] = React.useState([]);





    let [profile,setProfile] = React.useState({
        reward : '0' ,
        teamReward : '0' ,
        walletAmount : '0',
        full_name : 'Loading ... ',
        withdrawbleAmount : '0',
        avatar :'https://metamax.network/public/no-avatar.jpeg',
        myPack : [],
    });



    const logout = async ()=>{
        await  AsyncStorage.removeItem('token');
        navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
        });
    }





    const withdraw = async (id)=>{
        let token = await AsyncStorage.getItem('token');


        clearInterval(interval);

        let formData = new FormData();
        formData.append('token', token);
        formData.append('id', id);

        setToast('Send Data to Server ...');
        // Toast.showLoading('Send Data to Server ...');
        let res = await axios.post(
            `${Config.base}/api/v1/withdraw`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });

        setToast(false);

        // Toast.hide('');
        if(res.data.status == 200){
            // Toast.showSuccess(res.data.message);
            getData();
        }else{
            // Toast.show(res.data.message);

        }
        setToast(res.data.message);

        const timeoutId = setTimeout(() => {
            setToast(false);
        }, 3000);
    }



    const activeTimer = (data)=>{


        let newdata = [];
        data.map((item,index)=>{
            newdata[index] = item;
        });
        setTimers(newdata);
    }


    useFocusEffect(
        React.useCallback(() => {
            getData();
            return () => {
                if(interval){
                    clearInterval(interval);
                }

            };
        }, [])
    );

    const getData = async ()=>{
        let token = await AsyncStorage.getItem('token');


        let res = await axios.get(
            `${Config.base}/api/v1/profile`,
            { params:
                    {
                        token: token
                    }
            }
        );
        profile = res.data;
        setProfile(res.data);

        //activeTimer(res.data.myPack);


        setpack(res.data.myPack);

        setdatas(res.data.myPack);

        // interval = setInterval(function () {
        //     activeTimer(res.data.myPack);
        // }, 1300);
    };


    const remaindDate = (input)=>{


        var date = Math.abs((new Date().getTime() / 1000).toFixed(0));
        var date2 = Math.abs((new Date(input.endDay).getTime() ).toFixed(0));


        var diff = date2 - date;


        if(diff <= 0){

            return (
                <TouchableOpacity onPress={()=>withdraw(input.id)} style={styles.btn}>
                    <Text  style={styles.btntext}>Withdraw Profit</Text>
                </TouchableOpacity>
            )
        }

        var days = Math.floor(diff / 86400);
        var hours = Math.floor(diff / 3600) % 24;
        var minutes = Math.floor(diff / 60) % 60;
        var seconds = diff % 60;

        var daysStr = days;
        if (days < 10) {
            daysStr = "0" + days;
        }

        var hoursStr = hours;
        if (hours < 10) {
            hoursStr = "0" + hours;
        }

        var minutesStr = minutes;
        if (minutes < 10) {
            minutesStr = "0" + minutes;
        }

        var secondsStr = seconds;
        if (seconds < 10) {
            secondsStr = "0" + seconds;
        }

        if (days < 0 && hours < 0 && minutes < 0 && seconds < 0) {
            daysStr = "00";
            hoursStr = "00";
            minutesStr = "00";
            secondsStr = "00";

            // console.log("close");
            // if (typeof interval !== "undefined") {
            //     clearInterval(interval);
            // }
        }




        let result =  daysStr + " days, " + hoursStr + ":" + minutesStr + ":" + secondsStr;


        return (
            <Text style={styles.rewardtext}>
                {result}
            </Text>
        );


        // console.log(daysStr + " days, " + hoursStr + ":" + minutesStr + ":" + secondsStr);


    }







    return (
        <View style={{flex : 1 , backgroundColor : '#03685f'}}>
            <LinearGradient
                // Background Linear Gradient
                colors={['#19222f', '#03685f']}
                // colors={['#662D8C', '#ED1E79']}

                // start={{ x: 0.0, y: 0.0 }}
                // end={{ x: 1, y: 1 }}
                style={styles.background}
            >
                <Text style={styles.header}> Personal </Text>
                {toast.length &&
                    <ToastNotification
                        // textStyle={{ color: 'red' }}
                        positionValue={0}
                        text={toast}
                        // duration={99999999999}
                        isTop={true}
                        style={{ padding: RFValue(10) , zIndex:99 }}
                    />
                }
                <View style={{flexDirection : 'row' , alignItems : 'center',}}>
                    <Image
                        resizeMode={'stretch'}
                        fadeDuration={999}
                        style={{
                            width : RFValue(50),
                            height : RFValue(50),
                            marginHorizontal : RFValue(15),
                            borderRadius : RFValue(100),
                            objectFit  : 'cover',
                            marginTop : 15
                        }}
                        source={{uri : profile.avatar}}
                    />
                    <View style={{justifyContent : 'space-between' , flex : 1 , minHeight : RFValue(60 ),backgroundColor : 'transparent'}}>
                        <Text style={styles.name}>{profile.full_name}</Text>
                        <Text style={styles.subname}>Active Profile </Text>
                    </View>

                    <View  style={{marginRight : RFValue(25),    marginTop : 15 , flexDirection : 'row'}}>

                        <TouchableOpacity style={{marginHorizontal : RFValue(5)}} onPress={()=>navigation.navigate('Password')} >


                            <Entypo name="key" size={RFValue(22)} color="yellow" />
                        </TouchableOpacity>
                        <TouchableOpacity style={{marginHorizontal : RFValue(5)}} onPress={()=>navigation.navigate('Edit')} >
                            <FontAwesome5 name="edit" size={RFValue(22)} color="#FFF"  />
                        </TouchableOpacity>

                        <TouchableOpacity style={{marginHorizontal : RFValue(5)}} onPress={logout} >
                            <AntDesign name="poweroff" size={RFValue(22)} color="red" />
                        </TouchableOpacity>

                    </View>
                </View>


                <View style={{flexDirection : 'row' , alignItems : 'center', justifyContent : 'space-around',marginTop : RFValue(10) , borderBottomWidth : 1 , borderColor : '#FFF' ,paddingBottom : RFValue(5)}}>
                    <TouchableOpacity onPress={()=>navigation.navigate('Wallet')} style={styles.rewardbox}>
                        <FontAwesome5 name="file-invoice-dollar" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.reward}> records </Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={()=>navigation.navigate('Friends')} style={styles.rewardbox}>
                        <FontAwesome name="users" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.reward}> Friends  </Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={()=>navigation.navigate('Invation')} style={styles.rewardbox}>
                        <MaterialCommunityIcons name="email-send-outline" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.reward}> Invitation </Text>
                    </TouchableOpacity>
                </View>




                <View style={{flexDirection : 'row' , alignItems : 'center', justifyContent : 'space-around',marginTop : RFValue(10) , paddingBottom : RFValue(15)}}>
                   <View style={styles.rewardbox}>
                       <Text style={styles.reward}>Team Reward </Text>
                       <Text style={styles.value}>{profile.teamReward} </Text>
                   </View>
                    <View style={styles.rewardbox}>
                        <Text style={styles.reward}>withdrawble</Text>

                        <Text style={styles.value}>{profile.withdrawbleAmount} </Text>
                    </View>
                    <View style={styles.rewardbox}>
                        <Text style={styles.reward}> My Reward</Text>
                        <Text style={styles.value}>{profile.reward} </Text>
                    </View>
                </View>



            </LinearGradient>



            {pack.length > 0 &&

                <ScrollView >

                    {pack.map((item,index)=>

                        <TouchableOpacity key={index} style={styles.box}>
                            <View style={{flexDirection : 'row',justifyContent : 'space-between',alignItems : 'center'}}>

                                <View style={{justifyContent : 'center',alignItems : 'center'}}>
                                    <Text style={styles.headertext}>
                                        {item.option2}
                                    </Text>

                                    <Image
                                        resizeMode={'stretch'}
                                        fadeDuration={999}
                                        style={{
                                            width : RFValue(100),
                                            height : RFValue(100),
                                            marginVertical : 20,
                                            borderRadius : 10,
                                        }}
                                        source={require('./../../assets/reward.jpg')}/>
                                </View>


                                <View style={{flex : 1 , alignItems : 'left',}}>
                                    <Text style={styles.titletext}>
                                        {item.name}
                                    </Text>

                                    <Text style={styles.returntext}>
                                        {item.option3}

                                    </Text>
                                    <Text style={styles.returntext}>

                                        {item.option4}
                                    </Text>


                                    <Text style={styles.titletext}>
                                        {item.option1}
                                    </Text>
                                </View>
                            </View>


                                {item.remain_day === 1 ?
                                    <>
                                        <View style={styles.footer}>


                                            <Text style={styles.rewardtext}>
                                                {item.remain_day} Day remain
                                            </Text>

                                            <TouchableOpacity onPress={()=>withdraw(item.id)} style={styles.btn}>
                                                <Text  style={styles.btntext}>Withdraw Balance</Text>
                                            </TouchableOpacity>

                                        </View>
                                    </>
                                :
                                    <View style={styles.footer}>


                                        <Text style={styles.rewardtext}>
                                            {item.remain_day} Day remain
                                        </Text>

                                        <TouchableOpacity onPress={()=>withdraw(item.id)} style={styles.btn}>
                                            <Text  style={styles.btntext}>Withdraw Profit</Text>
                                        </TouchableOpacity>

                                    </View>
                                }





                        </TouchableOpacity>

                    )}



                </ScrollView>

            }










        </View>
    );
}


const styles = StyleSheet.create({

    rewardbox : {
      justifyContent : "center",
        alignItems : 'center',
        paddingVertical :RFValue(10)
    },
    reward: {
        fontFamily :'novaria',
        color : '#FFF',
        textAlign : 'center',
        paddingHorizontal : RFValue(0),
        paddingTop : RFValue(3),
        fontSize : RFValue(14),
    },
    value: {
        fontFamily :'novaria',
        color : '#fff900',
        // color : '#2de281',

        paddingHorizontal : RFValue(0),
        paddingTop : RFValue(3),
        fontSize : RFValue(12),
        textAlign : 'center'
    },
    name:{
        fontFamily :'novaria',
        color : '#FFF',
        textAlign : 'left',
        paddingHorizontal : RFValue(0),
        paddingTop : RFValue(15),
        fontSize : RFValue(22),
    },
    subname:{
        fontFamily :'novaria',
        color : '#FFF',
        textAlign : 'left',
        paddingHorizontal : RFValue(0),
        // paddingTop : RFValue(15),
        fontSize : RFValue(12),
    },


    header:{
        fontFamily :'novaria',
        color : '#FFF',
        // textAlign : 'left',
        textAlign : 'center',
        paddingHorizontal : RFValue(25),
        paddingVertical : RFValue(10),
        paddingTop : RFValue(15),
        fontSize : RFValue(28),
    },
    background : {
        // flex : 1,
        // height : 215,
        // justifyContent : "center",
        // alignItems:'center',
        borderBottomEndRadius : 25,
        borderBottomRightRadius : 25,
        borderBottomLeftRadius : 25,
        // borderBottomWidth : 10,
        // borderBottomColor : 'red'
    },





    progress : {
        width : '85%',
        backgroundColor : '#8e2de2',
        height : RFValue(10),
        marginVertical : RFValue(15),
        borderRadius : RFValue(25),
        borderWidth : 2,
        borderColor : '#FFF',

    },

    rewardtext: {
        color : '#fff900',
        fontFamily : 'novaria',
        textAlign : "justify",
        fontSize : RFValue(12),
        paddingHorizontal : RFValue(10),
    },

    titletext : {
        color : '#FFF',
        fontFamily : 'novaria',
        textAlign : "justify",
        fontSize : RFValue(12),
        paddingHorizontal : RFValue(10),
        marginVertical : RFValue(10),
    },

    returntext:{
        color : '#f6f6f6',
        fontFamily : 'novaria',
        textAlign : "left",
        fontSize : RFValue(10),
        paddingHorizontal : RFValue(10),
        paddingVertical : RFValue(0),
    },


    footer : {
        borderTopWidth : 1 ,
        borderTopColor : '#FFF',
        paddingTop : RFValue(8),
        flexDirection : 'row',
        justifyContent : 'space-between',
        alignItems : 'center',
    },

    headertext : {
        flex : 1,
        color : '#FFF',
        fontFamily : 'novaria',
        textAlign : "center",
        fontSize : RFValue(14)
    },

    box :{
        backgroundColor : 'rgba(255, 255, 255,0.4)',
        marginHorizontal : RFValue(15),
        marginTop : RFValue(8),
        borderRadius : RFValue(10),
        padding : RFValue(15),

    },

    btn : {

        borderWidth : 1,
        borderColor : '#FFF',
        width : RFValue(125),
        justifyContent : "center",
        alignItems: 'center',
        alignSelf : "flex-end",

        padding : RFValue(7),
        borderRadius : RFValue(5),
        backgroundColor : '#07bdad',
        marginHorizontal : RFValue(8),



    },



    btntext : {
        color : '#FFF',
        fontFamily : 'novaria',
        fontSize : RFValue(11),

    },




});


export default Profile;
